export const PAGE_URL = {
  ROOT_PAGE : '/',
  PAGE_NOT_FOUND : '/page-not-found',
  NO_PERMISSION: '/no-permission-route'
};
